import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"

const url = process.env.GATSBY_SITE_URL

const MetaDecorator = ({
	title,
	description,
	imageUrl = "",
	imageAlt = "Fastvue",
	keywords,
	location,
}) => {
	const fullPath =
		location && location.pathname ? `${url}${location.pathname}${location.search || ""}` : url

	return (
		<Helmet
			htmlAttributes={{
				lang: "en",
			}}
			title={title}
			meta={[
				{
					name: "description",
					content: description,
				},
				{
					property: "og:title",
					content: title,
				},
				{
					property: "og:description",
					content: description,
				},
				{
					property: "keywords",
					content: keywords,
				},
				{
					property: "og:type",
					content: "website",
				},
				{
					property: "og:image",
					content: imageUrl,
				},
				{
					property: "og:image:alt",
					content: imageAlt,
				},
				{
					property: "og:image:width",
					content: "1200",
				},
				{
					property: "og:image:height",
					content: "630",
				},
				{
					property: "og:url",
					content: fullPath,
				},
				{
					property: "twitter:card",
					content: "summary_large_image",
				},
				{
					property: "twitter:title",
					content: title,
				},
				{
					property: "twitter:description",
					content: description,
				},
				{
					property: "twitter:image",
					content: imageUrl,
				},
				{
					property: "twitter:image:alt",
					content: imageAlt,
				},
			]}
		></Helmet>
	)
}

MetaDecorator.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	imageUrl: PropTypes.string,
	imageAlt: PropTypes.string,
}

export default MetaDecorator
